import { NodeViewProps } from '@tiptap/react';
import Moveable from 'react-moveable';

type ImageResizerProps = Pick<NodeViewProps, 'updateAttributes' | 'editor'> & {
  target: HTMLImageElement;
};
export const ImageResizer = ({
  editor,
  target,
  updateAttributes,
}: ImageResizerProps) => {
  const updateMediaSize = () => {
    if (target) {
      const { selection } = editor.state;
      updateAttributes({
        // @ts-ignore
        width: Number(target.style.width.replace('px', '')),
        height: Number(target.style.height.replace('px', '')),
      });
      editor.commands.setNodeSelection(selection.from);
    }
  };

  return (
    <Moveable
      target={target}
      container={null}
      origin={false}
      /* Resize event edges */
      edge={false}
      throttleDrag={0}
      /* When resize or scale, keeps a ratio of the width, height. */
      keepRatio
      /* resizable */
      /* Only one of resizable, scalable, warpable can be used. */
      resizable
      throttleResize={0}
      onResize={({
        target: el,
        width,
        height,
        // dist,
        delta,
      }: // direction,
      // clientX,
      // clientY,
      any) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        delta[0] && (el!.style.width = `${width}px`);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        delta[1] && (el!.style.height = `${height}px`);
      }}
      // { target, isDrag, clientX, clientY }: any
      onResizeEnd={() => {
        updateMediaSize();
      }}
      /* scalable */
      /* Only one of resizable, scalable, warpable can be used. */
      scalable
      throttleScale={0}
      /* Set the direction of resizable */
      renderDirections={['w', 'e']}
      onScale={({
        target: el,
        // scale,
        // dist,
        // delta,
        transform,
      }: // clientX,
      // clientY,
      any) => {
        el!.style.transform = transform;
      }}
    />
  );
};
